import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../reducers';

export const selectClientsState = createSelector(
  (state: RootState) => state,
  (state) => state.clients
);
